:host {
  display: block;
}

.vx-filter-container-desktop {
  display: none;
}

.vx-filter-container-mobile {
  display: none;
  position: fixed;
  background-color: #fff;
  width: 100%;
  inset: 0;
  z-index: 19999;
  overflow-x: hidden;
  isolation: isolate;
}

.vx-filter-container-mobile--open {
  display: block;
}

.vx-filter-container__close {
  transition: transform 150ms ease-in;
  background: none;
  border: none;
  position: absolute;
  padding: 4px;
  top: 17px;
  right: 17px;
  height: 28px;
  width: 28px;
  font-size: 0;
  line-height: 0;
  display: inline-block;
  z-index: 2;
}
.vx-filter-container__close::after {
  height: 20px;
  width: 20px;
  position: static;
  top: auto;
  content: "";
  display: inline-block;
  mask-size: contain;
  /* stylelint-disable-next-line property-no-vendor-prefix -- mask-properties dont work in chrome without webkit-prefix */
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
  /* stylelint-disable-next-line property-no-vendor-prefix -- mask-properties dont work in chrome without webkit-prefix */
  -webkit-mask-repeat: no-repeat;
  background-color: var(--ci-neutral900, #fff);
  mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43MTAxIDEuNzA3MTFDMTYuMTAwNiAxLjMxNjU4IDE2LjEwMDYgMC42ODM0MTcgMTUuNzEwMSAwLjI5Mjg5M0MxNS4zMTk1IC0wLjA5NzYzMTEgMTQuNjg2NCAtMC4wOTc2MzExIDE0LjI5NTggMC4yOTI4OTNMOC4wMDE0NyA2LjU4NzI2TDEuNzA3MTEgMC4yOTI4OTNDMS4zMTY1OCAtMC4wOTc2MzExIDAuNjgzNDE3IC0wLjA5NzYzMTEgMC4yOTI4OTMgMC4yOTI4OTNDLTAuMDk3NjMxMSAwLjY4MzQxNyAtMC4wOTc2MzExIDEuMzE2NTggMC4yOTI4OTMgMS43MDcxMUw2LjU4NzI2IDguMDAxNDdMMC4yOTI4OTMgMTQuMjk1OEMtMC4wOTc2MzExIDE0LjY4NjQgLTAuMDk3NjMxMSAxNS4zMTk1IDAuMjkyODkzIDE1LjcxMDFDMC42ODM0MTcgMTYuMTAwNiAxLjMxNjU4IDE2LjEwMDYgMS43MDcxMSAxNS43MTAxTDguMDAxNDcgOS40MTU2OUwxNC4yOTU4IDE1LjcxMDFDMTQuNjg2NCAxNi4xMDA2IDE1LjMxOTUgMTYuMTAwNiAxNS43MTAxIDE1LjcxMDFDMTYuMTAwNiAxNS4zMTk1IDE2LjEwMDYgMTQuNjg2NCAxNS43MTAxIDE0LjI5NThMOS40MTU2OSA4LjAwMTQ3TDE1LjcxMDEgMS43MDcxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=);
  /* stylelint-disable-next-line property-no-vendor-prefix -- mask-properties dont work in chrome without webkit-prefix */
  -webkit-mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43MTAxIDEuNzA3MTFDMTYuMTAwNiAxLjMxNjU4IDE2LjEwMDYgMC42ODM0MTcgMTUuNzEwMSAwLjI5Mjg5M0MxNS4zMTk1IC0wLjA5NzYzMTEgMTQuNjg2NCAtMC4wOTc2MzExIDE0LjI5NTggMC4yOTI4OTNMOC4wMDE0NyA2LjU4NzI2TDEuNzA3MTEgMC4yOTI4OTNDMS4zMTY1OCAtMC4wOTc2MzExIDAuNjgzNDE3IC0wLjA5NzYzMTEgMC4yOTI4OTMgMC4yOTI4OTNDLTAuMDk3NjMxMSAwLjY4MzQxNyAtMC4wOTc2MzExIDEuMzE2NTggMC4yOTI4OTMgMS43MDcxMUw2LjU4NzI2IDguMDAxNDdMMC4yOTI4OTMgMTQuMjk1OEMtMC4wOTc2MzExIDE0LjY4NjQgLTAuMDk3NjMxMSAxNS4zMTk1IDAuMjkyODkzIDE1LjcxMDFDMC42ODM0MTcgMTYuMTAwNiAxLjMxNjU4IDE2LjEwMDYgMS43MDcxMSAxNS43MTAxTDguMDAxNDcgOS40MTU2OUwxNC4yOTU4IDE1LjcxMDFDMTQuNjg2NCAxNi4xMDA2IDE1LjMxOTUgMTYuMTAwNiAxNS43MTAxIDE1LjcxMDFDMTYuMTAwNiAxNS4zMTk1IDE2LjEwMDYgMTQuNjg2NCAxNS43MTAxIDE0LjI5NThMOS40MTU2OSA4LjAwMTQ3TDE1LjcxMDEgMS43MDcxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=);
}

.vx-filter-container__button {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0;
  margin: 2px 0;
  background-color: var(--vx-filter-container--button-background-color, transparent);
  border: 0;
  color: var(--vx-filter-container--button-text-color, #000);
  text-align: var(--vx-filter-container--button-text-align, center);
  font-size: var(--vx-filter-container--button-font-size, 1.1428em);
  font-weight: var(--vx-filter-container--button-text-font-weight, 600);
  line-height: 1;
}

.vx-filter-container__filter-count {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 22px;
  min-height: 22px;
  padding: 0 5px;
  margin-top: 2px;
  margin-left: 5px;
  border: 1px solid #666;
  border-radius: 15px;
  font-size: var(--vx-filter-container--button-filter-count-font-size, 1.2rem);
  font-weight: var(--vx-filter-container--button-filter-count-weight, 400);
  line-height: 20px;
}

.vx-filter-container__filter {
  position: relative;
}

.vx-filter-container__filter-button {
  border: 0;
  background-color: var(--vx-filter-container--filter-button-background-color, transparent);
  font-size: var(--vx-filter-container--filter-button-font-size, 1.1428em);
  position: relative;
  display: block;
  width: 100%;
  height: 50px;
  margin: 0;
  padding: 0 30px 0 8px;
  line-height: 1;
  color: var(--vx-filter-container--filter-text-color, #000);
  font-weight: var(--vx-filter-container--filter-text-font-weight, 600);
  text-align: var(--vx-filter-container--filter-text-align, left);
}
.vx-filter-container__filter-button::after {
  content: " ";
  display: inline-block;
  width: 10px;
  height: 10px;
  position: absolute;
  right: 15px;
  transform: rotate(-45deg) translateX(-9px) translateY(-9px);
  border-color: black;
  border-width: 8px;
  border-right: solid;
  border-bottom: solid;
}

.vx-filter-container__page-heading {
  line-height: 1;
  color: var(--vx-filter-container--page-header-text-color, #000);
  font-size: var(--vx-filter-container--page-header-text-font-size, 1.625em);
  font-weight: var(--vx-filter-container--page-header-text-font-weight, 700);
}

.vx-filter-container__search-input {
  margin-top: 31px;
}

.vx-filter-container__filter-value-set vx-checkbox {
  display: block;
  margin-bottom: 26px;
}

.vx-filter-container__selected-filter {
  margin: 10px 0;
}

@media only screen and (min-width: 768px) {
  :host {
    display: flex;
  }
  .vx-filter-container-mobile {
    display: none;
  }
  .vx-filter-container-desktop {
    display: flex;
    position: relative;
    flex-wrap: wrap;
    gap: var(--vx-filter-container--desktop-row-gap, 1px) var(--vx-filter-container--desktop-column-gap, 20px);
    height: auto;
    width: 100%;
    padding: 0;
    max-height: 1000px;
    transition: max-height 150ms;
  }
  .vx-filter-container__button {
    display: none;
  }
  .vx-filter-container__filter-button {
    border-radius: 8px;
    width: auto;
    height: 56px;
  }
  .vx-filter-container__filter--open .vx-filter-container__filter-button {
    border-radius: 8px 8px 0 0;
  }
  .vx-filter-container__filter-button::after {
    content: " ";
    display: inline-block;
    width: 10px;
    height: 10px;
    transform: rotate(45deg) translateX(3px) translateY(-2px);
    border-color: black;
    border-width: 8px;
    border-right: solid;
    border-bottom: solid;
  }
  .vx-filter-container__filter-button:focus-visible, .vx-filter-container__filter-button:hover {
    outline: none;
    background: var(--ci-primary400);
    color: #fff;
    transition-property: color, background-color;
    transition-duration: 0.3s;
    transition-timing-function: ease;
  }
  .vx-filter-container__filter-categories-hide {
    max-height: 56px;
    overflow: hidden;
  }
  .vx-filter-container__toggle-wrapper {
    display: flex;
    justify-content: end;
    align-items: flex-start;
    width: 20%;
    margin-top: 17px;
  }
  .vx-filter-container__filter--open > .vx-filter-container__filter-button::after {
    transform: rotate(-135deg) translateX(-3px) translateY(2px);
    margin-top: 5px;
  }
  .vx-filter-container__filter-value-set {
    display: block;
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: 40px;
    left: 0;
    width: 333px;
    background-color: #fff;
    padding: 20px 0 10px 10px;
    z-index: 5;
    box-shadow: 0 5px 15px var(--ci-neutral300);
    border: 1px solid var(--neutral-300, #ECECEC);
    transition: top 0.3s ease, opacity 0.3s ease, visibility 0.3s 0s linear;
  }
  .vx-filter-container__filter-value-set--loading {
    overflow-y: hidden;
  }
  .vx-filter-container__filter-value-set--scroll {
    overflow-y: auto;
    max-height: 400px;
    padding-right: 20px;
  }
  .vx-filter-container__filter-close-button--wrapper {
    text-align: center;
    padding: 10px 20px 0 0;
  }
  .vx-filter-container__filter-close-button {
    width: 100%;
    border-radius: 5px;
    background: var(--ci-primary400);
    appearance: none;
    height: 40px;
    border: 1px solid;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1.1px;
  }
  .vx-filter-container__filter-close-button:hover {
    opacity: 0.9;
  }
  .vx-filter-container__filter-close-button:active {
    opacity: 0.5;
  }
  .vx-filter-container__filter-close-button:focus-visible {
    background: var(--ci-primary500);
  }
  .vx-filter-container__filter--open > .vx-filter-container__filter-value-set {
    visibility: visible;
    opacity: 1;
    top: 56px;
    transition: top 0.3s ease, opacity 0.3s ease, visibility 0s linear;
  }
  .vx-filter-container__filter-value-set vx-checkbox {
    margin-bottom: 0;
  }
  .vx-filter-container__toggle-button {
    display: flex;
    align-items: center;
    appearance: none;
    border: none;
    background: transparent;
    line-height: 1.2em;
    font-size: 14px;
    transition: color 250ms;
  }
  .vx-filter-container__toggle-button.vx-filter-container__toggle-button-hide {
    color: var(--ci-neutral700);
  }
  .vx-filter-container__toggle-button:hover {
    color: var(--ci-primary500);
  }
  .vx-filter-container__toggle-button:hover .vx-filter-container__svg-toggle {
    fill: var(--ci-primary500);
  }
  .vx-filter-container__svg-toggle {
    margin: 2px 0 0 2px;
    width: 18px;
    height: 18px;
    transition: transform 0.2s;
    transform: rotate(180deg);
    fill: var(--ci-neutral600);
  }
  .vx-filter-container__toggle-button-hide .vx-filter-container__svg-toggle {
    transform: rotate(0);
  }
}